<template>
  <a-card :bordered="false">
    <a-row style="margin-bottom: 16px">
      <a-col :span="14">
        <a-form-model layout="inline">
          <a-form-model-item label="内容名称">
            <a-input placeholder="请输入内容" :maxLength="30" v-model.trim="searchForm.name" />
          </a-form-model-item>
          <a-form-model-item>
            <a-button type="primary" @click="getPageList(true)"> 查询</a-button>
          </a-form-model-item>
        </a-form-model>
      </a-col>
      <a-col :span="10" style="text-align: end">
        <a-button type="primary" icon="plus" style="margin-right: 16px" @click="addContent"> 添加体验游戏 </a-button>
        <a-button v-if="tableRelevant.tableDataSource.length" icon="setting" @click="onSettingRule()"> 推荐规则 </a-button>
      </a-col>
    </a-row>
    <a-row>
      <a-col>
        <a-table
          :columns="columns"
          rowKey="id"
          :pagination="tableRelevant.tablePagination"
          :loading="tableRelevant.tableLoading"
          :locale="tableRelevant.locale"
          :dataSource="tableRelevant.tableDataSource"
        >
          <div slot="ability" slot-scope="text">
            <div v-for="item in text.abilitys">{{ item.abilityTypeName }} - {{ item.firstAbilityName }} - {{ item.secondAbilityName }}</div>
          </div>
          <div slot="course" slot-scope="text">
            {{ text.contentConfig.map((v) => v.courseName).join('，') }}
          </div>
          <div slot="action" class="action" slot-scope="text, record">
            <a-button type="link" :class="{ 'c-red': text.contentConfig[0] && text.contentConfig[0].isRegularContent }" @click="topStory(text)">{{
              text.contentConfig[0] && text.contentConfig[0].isRegularContent ? '已置顶' : '置顶'
            }}</a-button>
            <a-button type="link" @click="viewRecord(text)">查看</a-button>
            <a-button type="link" class="c-red" @click="removeRecord(text)" :loading="text.removeLoading">移除</a-button>
          </div>
        </a-table>
      </a-col>
    </a-row>
    <SelectGameContent ref="selectGameContentRef" title="添加体验游戏" />
    <SelectCourse ref="selectCourseRef" />
    <SettingRules ref="settingRulesRef" />
  </a-card>
</template>
<script>
import { tableRelevant } from '@/pages/projectImpl/js/utils'
import SelectGameContent from './component/selectGameContent'
import SettingRules from './component/settingRules.vue'
import SelectCourse from './component/selectCourse.vue'
import { Course, CourseResource } from '../../../../../utils/http'

const columns = [
  {
    dataIndex: 'contentName',
    title: '游戏名称',
  },
  {
    dataIndex: 'version',
    title: '版本',
  },
  {
    title: '能力维度',
    scopedSlots: { customRender: 'ability' },
  },
  {
    scopedSlots: { customRender: 'course' },
    title: '应用课程',
  },
  {
    title: '操作',
    scopedSlots: { customRender: 'action' },
  },
]
export default {
  name: 'ExperienceContent',
  components: { SelectGameContent, SettingRules, SelectCourse },
  data() {
    return {
      tableRelevant: tableRelevant.call(this),
      columns: Object.freeze(columns),
      searchForm: {
        name: undefined,
      },
    }
  },
  created() {
    this.defaultSetting = {
      trialGameRatio: 40,
      minOfficialGames: 1,
      minIntervalLessons: 1,
    }
    this.tableRelevant.locale.emptyText = '还没有添加体验游戏'
    this.getPageList(1)
  },
  computed: {
    getContentAbilitys() {
      return (contentConfig) => {
        const ability = []
        const abilitySet = new Set()
        contentConfig
          .map((v) => v.contentAbilitys)
          .flat(2)
          .forEach((item) => {
            if (!abilitySet.has(item.id)) {
              abilitySet.add(item.id)
              ability.push(item)
            }
          })

        return ability
      }
    },
  },
  methods: {
    async getPageList(reset) {
      if (reset) {
        this.tableRelevant.tablePagination.current = 1
      }
      this.tableRelevant.tableLoading = true
      const seriesInfo = this.$store.getters['course/getSeriesInfo']()
      const params = {
        pageIndex: this.tableRelevant.tablePagination.current,
        pageSize: this.tableRelevant.tablePagination.pageSize,
        name: this.searchForm.name === '' ? undefined : this.searchForm.name,
        CourseSeriesId: seriesInfo.id,
      }
      const { data } = await CourseResource.getExperienceList(params).finally(() => {
        this.tableRelevant.tableLoading = false
      })
      this.tableRelevant.tableDataSource = data.items
      this.tableRelevant.tablePagination.total = data.totalCount
    },
    async topStory(record) {
      await CourseResource.pinExperienceList({
        isRegularContent: !record.contentConfig[0]?.isRegularContent,
        contentConfigIds: record.contentConfig.map((v) => v.id),
      })
      this.getPageList(true)
      this.$message.success(record.contentConfig[0]?.isRegularContent ? '已取消置顶' : '置顶成功')
    },
    async removeRecord(record) {
      const seriesInfo = this.$store.getters['course/getSeriesInfo']()
      this.$set(record, 'removeLoading', true)
      const { data } = await CourseResource.checkRemoveExperience({ courseSeriesId: seriesInfo.id, contentId: record.contentId }).finally(() => {
        this.$set(record, 'removeLoading', false)
      })
      this.$confirm({
        title: '确定将该游戏移出体验库？',
        content: data ? '该游戏已存在系列的普通内容中，移除后不影响正式课程游戏推荐' : '该游戏未存在系列的普通内容中，移除后课程内将不推荐该游戏',
        centered: true,
        onOk: async () => {
          await CourseResource.delExperienceList({ contentConfigIds: record.contentConfig.map((v) => v.id) })
          this.getPageList(true)
          this.$message.success('操作成功')
        },
      })
    },
    async viewRecord(record) {
      this.$router.push({
        path: '/index/Analysis',
        query: {
          gameName: record.name,
          gameId: record.contentId,
          active: 3,
        },
      })
    },
    async onSettingCatchHander() {
      const seriesInfo = this.$store.getters['course/getSeriesInfo']()
      const params = {
        CourseSeriesId: seriesInfo.id,
      }
      const { data } = await CourseResource.courseAll(params)
      await CourseResource.settingRecommendRule(data.map((c) => ({ ...this.defaultSetting, courseId: c.id })))
      return Promise.reject()
    },
    async onSettingRule(options = {}) {
      let { settingForm, init } = options
      const catchHander = init ? this.onSettingCatchHander.bind(this) : () => Promise.reject()
      settingForm = await this.$refs['settingRulesRef'].showModal({ settingForm })
      const { keys, type } = await this.$refs['selectCourseRef'].showModal()
      if (type == 'prev') {
        return this.onSettingRule({ settingForm, init })
      }
      const params = keys.map((key) => ({ ...settingForm, courseId: key }))

      await CourseResource.settingRecommendRule(params)
      this.getPageList(true)
      this.$message.success('操作成功')
    },
    async addContent() {
      await this.$refs['selectGameContentRef'].showModal()
      if (!this.tableRelevant.tableDataSource.length) {
        this.onSettingRule({ init: true, settingForm: { ...this.defaultSetting } })
      }
      this.$message.success('操作成功')
      this.getPageList(1)
    },
  },
}
</script>

<style scoped lang="less">
.c-red {
  color: red;
}
</style>
